import { render } from "./VueDrawingCanvasWrapper.vue?vue&type=template&id=36f474fb"
import script from "./VueDrawingCanvasWrapper.vue?vue&type=script&lang=js"
export * from "./VueDrawingCanvasWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__